export default __webpack_public_path__ + "static/media/Telegram.881c969e.svg";